<template>
  <span>
    <div v-if="!isViewCost">
      <span class="icon is-inline-block">
        <i class="fal fa-eye" @click.stop.prevent="viewSupplementalCost()" title="View"></i>
      </span>
    </div>
    <portal to="global-modal-portal" :disabled="!usePortal" v-if="isViewCost">
      <b-modal :active.sync="isViewCost" scroll="keep" :has-modal-card="true">
        <div class="modal-card" style="min-width: 640px; max-height: 90vh; overflow-y: auto;">
          <header class="modal-card-head">
            <p class="modal-card-title">View Supplemental Cost</p>
          </header>
          <section class="modal-card-body" style="padding:12px">
            <div class="columns is-multiline">
              <div class="column is-12">
                <label class="label">Name</label>
                <div class="field">
                  {{ value.name }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Payee Type</label>
                <div class="field">
                  {{ value.payeeType }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Vendor</label>
                <div class="field">
                  {{ value.vendorName || '-' }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Nett Action</label>
                <div class="field">
                  {{ processingAction }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Cost Price</label>
                <div class="field">
                  {{ value.cost | currency }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Selling Price</label>
                <div class="field">
                  {{ value.sellingPrice | currency }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Applies to Disposition Intention</label>
                <div class="field">
                  {{ appliesToDispositionIntention }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Is In GL Balance</label>
                <div class="field">
                  {{ humanizedSwitch(value.isInGlBalance) }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Include In Agreements</label>
                <div class="field">
                  {{ humanizedSwitch(value.includeInAgreements) }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Add*</label>
                <div class="field">
                  {{ humanizedSwitch(value.additionalIncome) }}
                </div>
              </div>
              <div class="column is-4">
                <label class="label">Process Check Request/PO on Sale Only</label>
                <div class="field">
                  {{ humanizedSwitch(value.appliesOnSaleOnly) }}
                </div>
              </div>
              <div class="column is-12">
                <label class="label">Description</label>
                <div class="control">
                  <textarea name="description" class="textarea" type="text" :value="value.description" :disabled="true"></textarea>
                </div>
              </div>
              <div class="column is-12">
                <file-selector
                v-model="supplementPhotoFiles"
                label="Files"
                :multiple="true"
                :isBoxed="false"
                displaySize="64"
                :usePortalViewer="false"
                :enabled="false">
                </file-selector>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot is-block">
            <button class="button is-danger" @click="onCancel()" type="button">Cancel</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </span>
</template>

<script>
import utilitiesMixin from '@/mixins/generic/utilities'
import FileSelector from '@/components/generic/FileSelector'
import humanizedSwitchMixin from '@/mixins/generic/humanizedSwitches'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  components: {
    'file-selector': FileSelector
  },
  name: 'SupplementalCostViewComponent',
  mixins: [utilitiesMixin, humanizedSwitchMixin],
  props: {
    value: {
      type: Object,
      default: null
    },
    usePortal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      instanceId: this.$uuid.v4(),
      supplementPhotoFiles: [],
      isViewCost: false
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    appliesToDispositionIntention: function () {
      if (!this.value) return ''
      const match = this.definedTypes.defaultCostDispositionIntentions.options.find(
        y => y.name === this.value.appliesToDispositionIntention || 
            y.altName === this.value.appliesToDispositionIntention
      )
      return match ? match.name : ''
    },
    processingAction: function () {
      if (!this.value) return ''
      const match = this.definedTypes.defaultCostProcessingActions.options.find(
        y => y.name === this.value.processingAction || 
            y.altName === this.value.processingAction
      )
      return match ? match.name : ''
    }
  },
  methods: {
    viewSupplementalCost: function () {
      this.isViewCost = true
    },
    onCancel: function () {
      this.isViewCost = false
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.supplementPhotoFiles = []
      if (newValue && (newValue.attachments && newValue.attachments.length > 0)) {
        newValue.attachments.forEach((x) => {
          x.loaded = true
          x.imageData = x.fileLocation ? x.fileLocation : x.imageData
          x.fileType = x.fileLocation ? this.getFileType(x.fileLocation) : x.fileType
          x.name = x.name ? x.name : x.uploadName
          this.supplementPhotoFiles.push(x)
        })
      }
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>

  .modal-card-body {
    overflow:auto;
    height: calc(50vh - 10px);
  }

  .column {
    padding: 1rem;
  }

  .box {
    background-color: #f6f8fa;
  }

  .animation-content {
    max-width: 700px;
  }

  .process-info {
    margin-top: 10px;
  }
</style>
